import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as editingVariables from '../../editing-variables'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'
/**
 * When app is selected or marked for editing, put it's variables to editing
 * state.
 */
export const syncAppVariablesForEditing = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    appEc: Collection,
    editingVariablesFeature: editingVariables.Feature,
  ) =>
    appEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asObservable.pipe(
        rxjs.map(app =>
          !app
            ? editingVariablesFeature.actions.reset
                .from('syncAppVariablesForEditing (effect)')
                .create()
            : app.sessionVariables?.length
              ? editingVariablesFeature.actions.putInitialDefinitions
                  .from('syncAppVariablesForEditing (effect)')
                  .create(app.sessionVariables)
              : store.effects.SKIP,
        ),
      ),
)
